// ─────────────────────────────────────────────────────────────────
// Glass-i — Stage 6B.8A-3C: "Create Item" dropdown menu.
//
// Renders one AntD primary button that opens a dropdown of six
// options:
//   1. Glass
//   2. Hardware / Accessory
//   3. UPVC / Aluminium
//   4. Jobwork / Service
//   5. Ecom Product
//   6. Advanced Product Studio  ← navigates to the existing route
//
// Calls the parent's `onPick(kind)` for any kind in SIMPLE_KINDS,
// and `onAdvanced()` for the studio option. The parent owns modal
// state, so this component is purely the menu.
//
// Hidden if the user lacks erp.masters.items.create — the consumer
// is responsible for not rendering this when canCreate=false.
// ─────────────────────────────────────────────────────────────────

import { useMemo } from 'react';
import { Button, Dropdown } from 'antd';
import { DownOutlined, PlusOutlined } from '@ant-design/icons';
import { SIMPLE_CREATE_OPTIONS, SIMPLE_KINDS } from '../simpleCreateConstants';

export default function SimpleCreateMenu({ onPick, disabled }) {
  const items = useMemo(() => (
    SIMPLE_CREATE_OPTIONS.map((o) => ({
      key:   o.kind,
      label: (
        <div style={{ minWidth: 220, lineHeight: 1.25, padding: '2px 0' }}>
          <div style={{ fontWeight: 500 }}>{o.label}</div>
          <div style={{ fontSize: 11, color: '#888' }}>{o.hint}</div>
        </div>
      )
    }))
  ), []);

  const handleClick = ({ key }) => {
    if (Object.values(SIMPLE_KINDS).includes(key)) {
      onPick && onPick(key);
    }
  };

  return (
    <Dropdown
      menu={{ items, onClick: handleClick }}
      trigger={['click']}
      disabled={disabled}
      placement="bottomRight"
    >
      <Button type="primary" icon={<PlusOutlined />} disabled={disabled}>
        Create Item <DownOutlined style={{ marginInlineStart: 2 }} />
      </Button>
    </Dropdown>
  );
}
